import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Form, Button } from "react-bootstrap";
import "./ChangePassword.css";
import ModalSave from "../../ModalSave";
import { postData } from "../../../../utils/api";

import { InputGroup } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

const ChangePassword = ({ show, onHide }) => {
  const [formData, setFormData] = useState({
    email: "",
    old_password: "",
    new_password: "",
    confirm_password: "",
  });

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const [showPassword, setShowPassword] = useState({
    old: false,
    new: false,
    confirm: false,
  });

  const [errors, setErrors] = useState({});

  const strongPasswordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/;

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };

  const validate = () => {
    let newErrors = {};

    if (!formData.email) {
      newErrors.email = "Email is required";
    }

    if (!formData.old_password) {
      newErrors.old_password = "Old password is required";
    }

    if (!formData.new_password) {
      newErrors.new_password = "New password is required";
    } else if (!strongPasswordRegex.test(formData.new_password)) {
      newErrors.new_password =
        "Password must be 8+ chars with uppercase, lowercase, number & special character";
    }

    if (!formData.confirm_password) {
      newErrors.confirm_password = "Confirm password is required";
    } else if (formData.new_password !== formData.confirm_password) {
      newErrors.confirm_password = "Passwords do not match";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;
    try {
      const response = await postData(`/change-password`, formData);

      if (response.success) {
        setShowModal({
          code: response.code,
          message: response.message,
        });
        setTimeout(() => {
          setShowModal({ code: response.code, message: response.message });
          onHide();
        }, 2000);
      } else {
        setShowModal({ code: response.code, message: response.message });
        setTimeout(() => {
          setShowModal(false);
          // onHide();
        }, 2000);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  return (
    <Modal
      className="common_modal Service_History_modal"
      centered
      show={show}
      onHide={onHide}
      size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Change Password</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Email</Form.Label>

            <InputGroup>
              <Form.Control
                type="text"
                name="email"
                value={formData.email}
                onChange={handleChange}
                isInvalid={!!errors.email}
              />
              <Form.Control.Feedback type="invalid">
                {errors.email}
              </Form.Control.Feedback>
            </InputGroup>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Old Password</Form.Label>

            <InputGroup>
              <Form.Control
                type={showPassword.old ? "text" : "password"}
                name="old_password"
                value={formData.old_password}
                onChange={handleChange}
                isInvalid={!!errors.old_password}
              />
              <InputGroup.Text
                style={{ cursor: "pointer" }}
                onClick={() =>
                  setShowPassword({ ...showPassword, old: !showPassword.old })
                }>
                <FontAwesomeIcon icon={showPassword.old ? faEyeSlash : faEye} />
              </InputGroup.Text>

              <Form.Control.Feedback type="invalid">
                {errors.old_password}
              </Form.Control.Feedback>
            </InputGroup>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>New Password</Form.Label>

            <InputGroup>
              <Form.Control
                type={showPassword.new ? "text" : "password"}
                name="new_password"
                value={formData.new_password}
                onChange={handleChange}
                isInvalid={!!errors.new_password}
              />
              <InputGroup.Text
                style={{ cursor: "pointer" }}
                onClick={() =>
                  setShowPassword({ ...showPassword, new: !showPassword.new })
                }>
                <FontAwesomeIcon icon={showPassword.new ? faEyeSlash : faEye} />
              </InputGroup.Text>

              <Form.Control.Feedback type="invalid">
                {errors.new_password}
              </Form.Control.Feedback>
            </InputGroup>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Confirm New Password</Form.Label>

            <InputGroup>
              <Form.Control
                type={showPassword.confirm ? "text" : "password"}
                name="confirm_password"
                value={formData.confirm_password}
                onChange={handleChange}
                isInvalid={!!errors.confirm_password}
              />
              <InputGroup.Text
                style={{ cursor: "pointer" }}
                onClick={() =>
                  setShowPassword({
                    ...showPassword,
                    confirm: !showPassword.confirm,
                  })
                }>
                <FontAwesomeIcon
                  icon={showPassword.confirm ? faEyeSlash : faEye}
                />
              </InputGroup.Text>

              <Form.Control.Feedback type="invalid">
                {errors.confirm_password}
              </Form.Control.Feedback>
            </InputGroup>
          </Form.Group>

          <div className="text-end">
            <Button variant="secondary" className="me-2" onClick={onHide}>
              Cancel
            </Button>
            <Button variant="primary" type="submit">
              Update Password
            </Button>
          </div>
        </Form>
      </Modal.Body>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </Modal>
  );
};

export default ChangePassword;
